import {ActionPayloadI} from "./actions-builder.types";

export interface FormPayloadI {
  title?: string,
  fields: Array<FormFieldI>

  actions?: Array<ActionPayloadI>

}


export interface FormFieldI{
  key: string,
  type?: FieldType,
  default?: any,
  editable?: boolean,
  validators?: ValidatorsI,
  label?: string,
  placeholder?: string,
  hint?: string,
  hidden?: boolean,
  options?: Array<string>
}

export enum FieldType {
  BOOL = 'checkbox',
  COLOR = 'color',
  DATE = 'date',
  DATE_TIME_LOCAL = 'datetime-local',
  EMAIL = 'email',
  FILE = 'file',
  IMAGE = 'image',
  MONTH = 'month',
  NUM = 'number',
  PASS = 'password',
  CHOICE = 'radio',
  RANGE = 'range',
  TEL = 'tel',
  TEXT = 'text',
  MULTILINE_TEXT = 'multiline-text',
  STRING_LIST = 'string_list',
  TIME = 'time',
  URL = 'url',
  WEEK = 'week',
  DROPDOWN = 'dropdown',
}


export interface ValidatorsI {
  [k: string]: any,
  min?: number,
  max?: number,
  required?: boolean
}

export interface Connection {
  id: number;
  connection_name: string;
  connection_type_id: string;
  username_id: string;
  is_source: boolean;
  is_destination: boolean;
  created_dtm: string;
  updated_dtm: string;
}
